/**
 * Do not edit directly, this file was auto-generated.
 */

import { css } from 'styled-components';
export const cssVariables = css``;
export const theme = {
  'surface/surface0': 'var(--mlb-2-1-0-color-neutral-neutral1400, #070a0d)',
  'surface/surface1': 'var(--mlb-2-1-0-color-neutral-neutral1300, #14191f)',
  'surface/surface2': 'var(--mlb-2-1-0-color-neutral-neutral1200, #232931)',
  'background/neutral': 'var(--mlb-2-1-0-color-neutral-neutral1100, #333b44)',
  'background/inverse': 'var(--mlb-2-1-0-color-neutral-neutral100, #f4f5f6)',
  'background/emphasis-subtle': 'rgba(82, 152, 255, var(--mlb-2-1-0-opacity-opacity10, 0.10))',
  'background/emphasis-bold': 'var(--mlb-2-1-0-color-blue-blue400, #5298ff)',
  'background/alert': 'var(--mlb-2-1-0-color-red-red1000, #450000)',
  'background/positive': 'var(--mlb-2-1-0-color-green-green1000, #002500)',
  'background/warning': 'var(--mlb-2-1-0-color-yellow-yellow1000, #370900)',
  'border/neutral-decorative': 'var(--mlb-2-1-0-color-neutral-neutral1100, #333b44)',
  'border/neutral-contrast': 'var(--mlb-2-1-0-color-neutral-neutral800, #6a7480)',
  'border/inverse': 'var(--mlb-2-1-0-color-neutral-neutral100, #f4f5f6)',
  'border/emphasis': 'var(--mlb-2-1-0-color-blue-blue400, #5298ff)',
  'border/alert': 'var(--mlb-2-1-0-color-red-red400, #f16966)',
  'border/positive': 'var(--mlb-2-1-0-color-green-green400, #5eb15c)',
  'text/primary': 'var(--mlb-2-1-0-color-neutral-neutral100, #f4f5f6)',
  'text/secondary': 'var(--mlb-2-1-0-color-neutral-neutral600, #959da8)',
  'text/inverse': 'var(--mlb-2-1-0-color-neutral-neutral1400, #070a0d)',
  'text/action': 'var(--mlb-2-1-0-color-blue-blue400, #5298ff)',
  'text/alert': 'var(--mlb-2-1-0-color-red-red400, #f16966)',
  'text/positive': 'var(--mlb-2-1-0-color-green-green400, #5eb15c)',
  'text/warning': 'var(--mlb-2-1-0-color-yellow-yellow400, #d08929)',
  'icon/primary': 'var(--mlb-2-1-0-color-neutral-neutral200, #e8eaed)',
  'icon/secondary': 'var(--mlb-2-1-0-color-neutral-neutral600, #959da8)',
  'icon/decorative': 'var(--mlb-2-1-0-color-neutral-neutral800, #6a7480)',
  'icon/inverse': 'var(--mlb-2-1-0-color-neutral-neutral1400, #070a0d)',
  'icon/action': 'var(--mlb-2-1-0-color-blue-blue400, #5298ff)',
  'icon/alert': 'var(--mlb-2-1-0-color-red-red400, #f16966)',
  'icon/positive': 'var(--mlb-2-1-0-color-green-green400, #5eb15c)',
  'icon/warning': 'var(--mlb-2-1-0-color-yellow-yellow400, #d08929)',
  'static/black': 'var(--mlb-2-1-0-color-black, #000000)',
  'static/white': 'var(--mlb-2-1-0-color-white, #ffffff)',
  'static/border/highlight': 'rgba(255, 255, 255, var(--mlb-2-1-0-opacity-opacity20, 0.2))',
  'static/overlay/default': 'rgba(0, 0, 0, var(--mlb-2-1-0-opacity-opacity40, 0.4))',
  'static/overlay/bold': 'rgba(0, 0, 0, var(--mlb-2-1-0-opacity-opacity70, 0.7))',
  'static/background/action': 'var(--mlb-2-1-0-color-blue-blue600, #0062e3)',
  'static/background/alert': 'var(--mlb-2-1-0-color-red-red600, #c61b2b)',
  'static/accent/blue-light': 'var(--mlb-2-1-0-color-blue-blue300, #7ab2ff)',
  'static/accent/blue-dark': 'var(--mlb-2-1-0-color-blue-blue700, #0048c7)',
  'static/accent/red-light': 'var(--mlb-2-1-0-color-red-red300, #fd8d87)',
  'static/accent/red-dark': 'var(--mlb-2-1-0-color-red-red700, #aa0013)',
  'static/accent/green-light': 'var(--mlb-2-1-0-color-green-green300, #84c681)',
  'static/accent/green-dark': 'var(--mlb-2-1-0-color-green-green700, #006c00)',
  'static/accent/yellow-light': 'var(--mlb-2-1-0-color-yellow-yellow300, #e0a561)',
  'static/accent/yellow-dark': 'var(--mlb-2-1-0-color-yellow-yellow700, #8c3c00)',
  'static/accent/purple-light': 'var(--mlb-2-1-0-color-purple-purple300, #b9a5e9)',
  'static/accent/purple-dark': 'var(--mlb-2-1-0-color-purple-purple700, #613f99)',
  'state/hover': 'rgba(255, 255, 255, var(--mlb-2-1-0-opacity-opacity5, 0.05))',
  'state/pressed': 'rgba(255, 255, 255, var(--mlb-2-1-0-opacity-opacity10, 0.10))',
  'state/skeleton-background': 'var(--mlb-2-1-0-color-neutral-neutral1100, #333b44)',
  'state/skeleton-overlay': 'var(--mlb-2-1-0-color-neutral-neutral1000, #444d58)',
  'shadow/shadow-small/blur': '16px',
  'shadow/shadow-small/spread': '0',
  'shadow/shadow-small/color': 'rgba(0,0,0,0.08)',
  'shadow/shadow-small/type': 'dropShadow',
  'shadow/shadow-small/offsetX': '0',
  'shadow/shadow-small/offsetY': '0',
  'shadow/shadow-medium/blur': '24px',
  'shadow/shadow-medium/spread': '0',
  'shadow/shadow-medium/color': 'rgba(0,0,0,0.08)',
  'shadow/shadow-medium/type': 'dropShadow',
  'shadow/shadow-medium/offsetX': '0',
  'shadow/shadow-medium/offsetY': '1px',
  'shadow/shadow-large/blur': '32px',
  'shadow/shadow-large/spread': '0',
  'shadow/shadow-large/color': 'rgba(0,0,0,0.08)',
  'shadow/shadow-large/type': 'dropShadow',
  'shadow/shadow-large/offsetX': '0',
  'shadow/shadow-large/offsetY': '10px',
  'gradient/fade-subtle-start': 'var(--mlb-2-1-0-color-neutral-neutral1400, #070a0d)',
  'gradient/fade-subtle-end': 'rgba(7, 10, 13, 0)',
  'gradient/fade-subtle':
    'linear-gradient(var(--mlb-2-1-0-gradient-fade-subtle-start, #070a0d) 0%, var(--mlb-2-1-0-gradient-fade-subtle-end, rgba(7, 10, 13, 0)) 100%)',
  'gradient/fade-subtle-90':
    'linear-gradient(90deg, var(--mlb-2-1-0-gradient-fade-subtle-start, #070a0d) 0%, var(--mlb-2-1-0-gradient-fade-subtle-end, rgba(7, 10, 13, 0)) 100%)',
  'gradient/fade-subtle-180':
    'linear-gradient(180deg, var(--mlb-2-1-0-gradient-fade-subtle-start, #070a0d) 0%, var(--mlb-2-1-0-gradient-fade-subtle-end, rgba(7, 10, 13, 0)) 100%)',
  'gradient/fade-subtle-270':
    'linear-gradient(270deg, var(--mlb-2-1-0-gradient-fade-subtle-start, #070a0d) 0%, var(--mlb-2-1-0-gradient-fade-subtle-end, rgba(7, 10, 13, 0)) 100%)',
};
